import EngineModule from '../EngineModule';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'header-fullWidth',
	dependencies :     [
		'oms-basket'
	],
	allowedCustomers : null,
	generateComponentConfiguration() {
		return {};
	},
	insertionPath : null
});
